import { Fetcher } from "@connect/fetcher";
import Cookies from "js-cookie";
import { setAuthError, setLocalToken } from "../states/auth";
import { router } from "../router";

export const fetcher = new Fetcher("/api", {});

const goodStatuses = [200, 201];

fetcher.setMiddleware({}, (inp) => {
  if (!goodStatuses.includes(inp.response.status)) {
    if (inp.response.status === 401) {
      setLocalToken();
    }
    throw {
      data: inp.data,
      status: inp.response.status,
    };
  } else {
    return inp.data;
  }
});
fetcher.setInterceptor({}, (inp) => {
  if (inp.response.status === 401) {
    const err = inp.data?.message || (inp.data?.error as string);
    if (err === "Token expired") {
      setAuthError("token-expired");
      router.push({ name: "error", params: { errtype: "token-expired" } });
    } else {
      setAuthError("bad-user");
      router.push({ name: "error", params: { errtype: "bad-user" } });
    }
  }
});

export function updateToken(token: string) {
  Cookies.set("vcs-auth", token, { expires: 3 });
}
